import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Navigate, Route, Routes, useParams } from 'react-router-dom';
import AuthPage from './AuthPage';
import CampaignsPage from './CampaignsPage';
import TrialAccessPage from './TrialAccessPage';
import App2OptiMix from './App2OptiMix';
import { clearAuthSession } from './authSession';
import { API_BASE } from './config/api';
import reportWebVitals from './reportWebVitals';

function RedirectDesignToCampaign() {
  const { publicId, citySlug } = useParams();
  return <Navigate to={`/${publicId}/${citySlug}`} replace />;
}

function ProtectedRoute({ children }) {
  const [state, setState] = React.useState({
    status: 'checking',
    access: null,
  });
  const token = localStorage.getItem('authToken');

  React.useEffect(() => {
    let cancelled = false;
    if (!token) {
      setState({ status: 'no_token', access: null });
      return () => {
        cancelled = true;
      };
    }

    const run = async () => {
      try {
        const response = await fetch(`${API_BASE}/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          if (response.status === 401) {
            clearAuthSession();
          }
          setState({ status: response.status === 401 ? 'no_token' : 'error', access: null });
          return;
        }
        const data = await response.json();
        if (cancelled) return;
        const access = data?.access || null;
        if (access?.hasAccess) {
          setState({ status: 'ok', access });
        } else {
          setState({ status: 'expired', access });
        }
      } catch {
        if (!cancelled) {
          setState({ status: 'error', access: null });
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!token || state.status === 'no_token') {
    return <Navigate to="/auth" replace />;
  }

  if (state.status === 'checking') {
    return <div style={{ padding: 20 }}>Проверяем доступ...</div>;
  }

  if (state.status === 'expired') {
    return <TrialAccessPage access={state.access} />;
  }

  if (state.status === 'error') {
    return <div style={{ padding: 20 }}>Не удалось проверить доступ. Попробуйте обновить страницу.</div>;
  }

  return children;
}

function AppRouter() {
  const token = localStorage.getItem('authToken');
  return (
    <Routes>
      <Route path="/auth" element={<AuthPage />} />
      <Route
        path="/campaigns"
        element={(
          <ProtectedRoute>
            <CampaignsPage />
          </ProtectedRoute>
        )}
      />
      {/* OptiMix at /:publicId/:citySlug; /design/* kept as redirects for old links */}
      <Route path="/design/:publicId/:citySlug" element={<RedirectDesignToCampaign />} />
      <Route path="/design/app2" element={<Navigate to="/campaigns" replace />} />
      <Route path="/:publicId/:citySlug" element={<App2OptiMix />} />
      <Route path="*" element={<Navigate to={token ? '/campaigns' : '/auth'} replace />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
